import InlineEditContainer from './containers/InlineEditContainer'

export default InlineEditContainer
